import { ButtonArrow } from "@/components/atoms/ButtonArrow";
import { DotsButton } from "@/components/atoms/DotsButton";
import type { TPlanMobileNavigator } from "./types";

export const PlanMobileNavigator = ({ slideNumber }: TPlanMobileNavigator) => {
  const PlanMobileNavigatorElement = document.createElement("div");
  PlanMobileNavigatorElement.className =
    "w-full bg-white flex items-center justify-between border-b border-gray-100 lg:hidden";

  PlanMobileNavigatorElement.appendChild(
    ButtonArrow({
      direction: "left",
      disabled: true,
      onClick: () => {
        console.log("button left click");
      },
    }),
  );

  PlanMobileNavigatorElement.innerHTML += /* html */ `
        <div id="wrapperDots" class="flex items-center gap-2"></div>    
    `;

  const wrapperDotsElement =
    PlanMobileNavigatorElement.querySelector("#wrapperDots");
  if (wrapperDotsElement) {
    [...Array(slideNumber)].forEach((_, index) => {
      wrapperDotsElement.appendChild(
        DotsButton({
          active: index === 0,
          onClick: () => console.log("button dot click"),
        }),
      );
    });
  }

  PlanMobileNavigatorElement.appendChild(
    ButtonArrow({
      direction: "right",
      disabled: false,
      onClick: () => {
        console.log("button right click");
      },
    }),
  );

  return PlanMobileNavigatorElement;
};
